<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户编号</label>
            <em class="weui-form-preview__value">{{form.main.cun_cucode}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <em class="weui-form-preview__value">{{form.main.cun_cuname}}</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户类型</label>
            <span class="weui-form-preview__value">{{form.main.cu_type}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.cu_nsrzh">
            <label class="weui-form-preview__label">纳税人识别号</label>
            <span class="weui-form-preview__value">{{form.main.cu_nsrzh}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.cu_bankaccount">
            <label class="weui-form-preview__label">开户行</label>
            <span class="weui-form-preview__value">{{form.main.cu_bankaccount}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.cu_bankcode">
            <label class="weui-form-preview__label">开户账号</label>
            <span class="weui-form-preview__value">{{form.main.cu_bankcode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.cu_invoiceinfo">
            <label class="weui-form-preview__label">开票地址</label>
            <span class="weui-form-preview__value">{{form.main.cu_invoiceinfo}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">收款方式</label>
            <span class="weui-form-preview__value">
              {{form.main.cu_payments}}
              <span v-if="form.main.cu_currency">{{form.main.cu_currency}}</span>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">税率(%)</label>
            <span class="weui-form-preview__value">{{form.main.cu_taxrate}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.cu_sellername">
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.cu_sellername}}
              <call-mobile :em-id="form.main.cu_sellerid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应收余额(元)</label>
            <span
              class="weui-form-preview__value"
              v-format="'¥#,##0.00'"
            >{{form.main.cu_leftamount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">信用额度</label>
            <span
              class="weui-form-preview__value"
              v-format="'¥#,##0.00'"
            >{{form.main.cu_credit}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
        >
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">挂起时间</label>
            <span class="weui-form-preview__value">{{form.main.cl_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">挂起原因</label>
            <span class="weui-form-preview__value">{{form.main.cl_reason}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.cl_paydate">
            <label class="weui-form-preview__label">应收日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.cl_paydate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">截止回款日</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.cun_enddate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">解挂原因</label>
            <span class="weui-form-preview__value">{{form.main.cun_remark}}</span>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import form from "@/mixins/form.js";
import CallMobile from "@/components/button/CallMobile.vue";

export default {
  mixins: [form],
  components: {
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/document/customerunlock"
    };
  }
};
</script>